import { YIBF_ESLESME_TALEP_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const yibfEslesmeTalepList = (userId) => {
    return getRequest({url:YIBF_ESLESME_TALEP_LISTESI+"?userId="+userId});
}

export default yibfEslesmeTalepList;